import { useQuery } from '@tanstack/react-query';
import { serviceChargeService } from '@/services/compensation';
import { serviceChargeKeys } from './queryKeys';

export const useServiceChargeDistribution = (
  periodId: string,
  startDate: Date,
  endDate: Date,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: serviceChargeKeys.distribution(
      periodId,
      startDate.toISOString(),
      endDate.toISOString()
    ),
    queryFn: () => serviceChargeService.previewDistribution(periodId, startDate, endDate),
    enabled: enabled && !!periodId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
